import React from "react";
import AdfoxBottomOverlay from "./AdfoxBottomOverlay";

export default class BottomAd extends React.Component {

    state = {
        showAd: false,
        shown: false
    };

    handleScroll = e => {
        if (pageYOffset > 200) {
            if (!this.state.shown) {
                this.setState({ showAd: true });
            }
        }
    };

    componentDidMount() {
        window.addEventListener("scroll", this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener("scroll", this.handleScroll);
    }

    render() {
        if (!this.state.showAd) {
            return null;
        }

        return (
            <div className="bottom-ad">
                <div className="bottom-ad__wrap">
                    <div
                        className="bottom-ad__closer"
                        onClick={() => {
                            this.setState({ shown: true, showAd: false });
                        }}
                    ></div>
                    <AdfoxBottomOverlay context={this.props.context}/>
                </div>
            </div>
        );
    }
}
